var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.search_return_null)?_c('h2',{staticClass:"c-loadingFailed"},[_vm._v("Oupsi ! We did not find any GIFs :(")]):_c('h2',{staticClass:"c-loadingFailed"},[_vm._v("Oupsi ! Something goes wrong :(")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a9769a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingFailed.vue
// module id = null
// module chunks = 